import Api from "./Api";
import Cookie from "js-cookie";

export default {
  getCookie(forceReload) {
    if(typeof forceReload == "undefined"){
        forceReload = false;
    }
      
    if(!forceReload){
        let token = Cookie.get("XSRF-TOKEN");
        if (token) {        
          return new Promise(resolve => {
            resolve(token);
          });
        }
    }
    return Api.get("/csrf-cookie");
  }
};